import React from "react";
import style from "../assets/css/components/ProxMatchs.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShieldAlt } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

function ProxMatchs({ match, tournament }) {
  return (
    <Link
      className={style.link}
      to={"/storymatch"}
      state={{ idMatch: match.id }}
    >
      <div className={style.card}>
        <div className={style.info}>
          <div className={style.contDesc}>
            <p className={style.nameLeague}>{tournament}</p>
            <p className={style.descMatch}>Liga · Jornada {match?.day}</p>
          </div>
          <div className={style.status}>
            <p className={style.text}>Live</p>
          </div>
        </div>
        <div className={style.contScore}>
          <div className={style.team}>
            <p className={style.shield}>
              <FontAwesomeIcon
                icon={faShieldAlt}
                color={match?.local?.colorShirt}
              />
            </p>
            <div className={style.teamName}>
              <p className={style.name}>{match?.local?.shortName}</p>
            </div>
          </div>
          <div className={style.score}>
            <p className={style.goal}>
              {match?.goalLocal}
              <span>-</span>
              {match?.goalVisit}
            </p>
            <p className={style.time}>{match?.StatusMatch}</p>
          </div>
          <div className={style.team}>
            <p className={style.shield}>
              <FontAwesomeIcon
                icon={faShieldAlt}
                color={match?.visit?.colorShirt}
              />
            </p>
            <div className={style.teamName}>
              <p className={style.name}>{match?.visit?.shortName}</p>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}

export default ProxMatchs;
